.error {
  flex-grow: 1;
  border: 1px solid var(--color-border-primary);
  border-radius: 4px;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  justify-content: center;
}
